import React from "react";
import { Box, Typography, styled } from "@mui/material";
import { DateSeparatorProps } from "../../../interfaces/all";
import { formatMessageDate } from "../../../utils/date";

const Container = styled(Box)({
  display: "flex",
  justifyContent: "center",
  alignItems: "center",
  padding: "8px 0",
  margin: "8px 0",
});

const Separator = styled(Box)({
  background: "rgba(225, 245, 254, 0.92)",
  padding: "4px 12px",
  borderRadius: "7.5px",
  boxShadow: "0 1px 0.5px rgba(11, 20, 26, 0.13)",
});

const DateText = styled(Typography)({
  fontSize: "12.5px",
  color: "#667781",
  textTransform: "none",
});

const DateSeparator: React.FC<DateSeparatorProps> = ({ date }) => {
  const formattedDate = formatMessageDate(date);

  return (
    <Container>
      <Separator>
        <DateText>{formattedDate}</DateText>
      </Separator>
    </Container>
  );
};

export default DateSeparator;
